import { FC } from "react";
import { getStorageUrlData } from "../../utils/files.utils";

export type HImageProps = JSX.IntrinsicElements["img"];

const HImage: FC<HImageProps> = ({ src = "", className, ...imgProps }) => {
  const { isAbsolute, url } = getStorageUrlData(src);

  return (
    <img
      alt={`${url}`}
      className={`himage ${className ?? ""}`}
      data-tag-type="hype"
      data-is-absolute={String(isAbsolute)}
      src={url}
      {...imgProps}
    />
  );
};

export { HImage };
